module.exports = __webpack_public_path__ + "assets/events_disasters_primary.dfb02238.svg";